import { render, staticRenderFns } from "./ExpertEdit.vue?vue&type=template&id=1f6574f0"
import script from "./ExpertEdit.vue?vue&type=script&lang=js"
export * from "./ExpertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports